<template>
<div class="chapter">
<div class="inner_page">
<h1 class="parnum"><a id="page_1">PART I</a></h1><a id="page_1">
<h1 class="partit">The Origins of the Pashtun Tribes</h1>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_Part01.vue?aab258d8